import { useAccountRepository } from '@frontend/repository';

export const useCreateMasterPinCodeModal = () => {
    const { currentAccount } = useAccountRepository();

    return {
        currentAccount
    };
};
